export default {
  404: "404",
  register: "Регистрация",
  login: "Войти",
  profit: "Профит",
  payout: "Целевая выплата",
  btnDouble: "2×",
  wagered: "Ставок сделано",
  deposit: "Депозит",
  inputFieldBtnMax: "Макс",
  bets: "Ставки",
  topHeaderAmount: "Сумма",
  resetPasswordTitle: "Сброс пароля",
  resetPasswordNewPasswordTitle: "Новый пароль",
  resetPasswordNewPasswordErrorsRequired: "Пароль обязателен.",
  resetPasswordNewPasswordErrorsMinLength: "Минимум 8 символов.",
  resetPasswordNewPasswordErrorsMaxLength: "Максимум 16 символов.",
  resetPasswordNewPasswordErrorsPattern:
    "Пароль должен быть 8–16 символов, содержать заглавные и строчные буквы, цифры и специальный символ (например, NextGen@123)",
  resetPasswordConfirmPasswordTitle: "Подтвердите пароль",
  resetPasswordConfirmPasswordErrorsNotMatched: "Пароли не совпадают.",
  resetPasswordResetBtn: "Сбросить",
  passwordResetSuccess: "Пароль изменён",
  resetPasswordWentWrong: "Что-то пошло не так!",
  partners: "Партнёры",
  submit: "Отправить",
  signinUsername: "Email / Имя пользователя",
  signinForgetPassword: "Забыли пароль?",
  signinErrorsUserNameRequired: "Введите имя пользователя / email.",
  signinErrorsPasswordRequired: "Пароль обязателен.",
  signinErrorsPasswordMinLength: "Минимум 8 символов.",
  signinErrorsPasswordMaxLength: "Максимум 16 символов.",
  signinTryAgain: "Что-то пошло не так, попробуйте снова.",
  signinResetPasswordUsernameErr:
    "Введите имя пользователя / email для сброса пароля.",
  signinResetMailSentSuccessContent:
    "Мы отправили ссылку для сброса пароля на ваш email. Проверьте почту и сбросьте пароль.",
  signupTitle: "Регистрация",
  signupUsername: "Имя пользователя",
  signupEmail: "Email",
  signupWalletConnect: "Войти через кошелёк",
  signupPassword: "Пароль",
  signupErrorsUserNameRequired: "Введите имя пользователя.",
  signupErrorsFirstNameRequired: "Введите имя.",
  signupErrorsLastNameRequired: "Введите фамилию.",
  signupErrorsUserNameMinLength: "Минимум {{minimumCharacters}} символов.",
  signupErrorsUserNameMaxLength: "Максимум {{maximumCharacters}} символов.",
  signupErrorsUserNamePattern: "Можно использовать только буквы и цифры.",
  signupErrorsStringPattern: "Можно использовать только буквы.",
  signupErrorsEmailRequired: "Введите email.",
  signupErrorsEmailPattern: "Введите корректный email.",
  signupErrorsPasswordRequired: "Пароль обязателен.",
  signupErrorsPasswordMinLength: "Минимум 8 символов.",
  signupErrorsPasswordMaxLength: "Максимум 16 символов.",
  signupErrorsPasswordPattern:
    "Пароль должен быть 8–16 символов, содержать заглавные и строчные буквы, цифры и специальный символ (например, NextGen@123)",
  otpIsRequired: "OTP обязателен",
  otpMustBeSixDigits: "OTP должен быть из 6 цифр",
  enterOtp: "Введите OTP",
  accountMenuTransactions: "Транзакции",
  accountMenuPromotions: "Промоакции",
  accountMenuProfile: "Профиль",
  accountMenuLogout: "Выйти",
  accountMenuWithdraw: "Вывод",
  pageNotFound: "Мы не можем найти страницу, которую вы ищете!",
  error: "Ошибка",
  somethingWentWrong: "Что-то пошло не так!",
  verifyEmailThankYou: "Спасибо!",
  verifyEmailEmailIsVerified: "Ваш email подтверждён.",
  verifyEmailWentWrong: "Что-то пошло не так!",
  verifyEmailTokenExpired: "Email уже подтверждён или ссылка просрочена",
  create: "Создать",
  profilePassword: "Пароль",
  profileUploadProfile: "Загрузить фото",
  profileErrorsEmailRequired: "Email обязателен.",
  profileErrorsEmailPattern: "Введите корректный email.",
  profileErrorsEmailMinLength: "Минимум 3 символа.",
  profileErrorsEmailMaxLength: "Максимум 20 символов.",
  profileMessagesProfileUpdate: "Профиль обновлён",
  profileMessagesChangePassword: "Пароль обновлён",
  profileProfilePicProfilePicUpload: "Загрузить изображение профиля",
  profileNoNewChanges: "Не удалось обновить профиль! Нет новых изменений.",
  profileLoggedInWithSocial: "Вы вошли через социальную сеть.",
  profileSideNavigatorSound: "Звук",
  profileSideNavigatorMusic: "Музыка",
  profileSideNavigatorProfile: "Мой профиль",
  profileSideNavigatorBetHistory: "История ставок",
  profileSideNavigatorTransactions: "Транзакции",
  profileSideNavigatorDeposit: "Депозит",
  withdraw: "Вывод",
  profileSideNavigatorGameLimits: "Лимиты игры",
  profileSideNavigatorReferral: "Реферальная программа",
  profileSideNavigatorChangePassword: "Изменить пароль",
  profileSideNavigatorTermsConditions: "Условия и положения",
  profileSideNavigatorLogOut: "Выйти",
  profileSideNavigatorProvablyFair: "Доказуемая честность",
  WalletInfoSectionNotAvailable: "Недоступно",
  WalletInfoSectionRealBalance: "Реальный баланс",
  GameLimitsMinimumBet: "Минимальная ставка",
  GameLimitsMaximumBet: "Максимальная ставка",
  GameLimitsMaxWinFor1Bet: "Максимальный выигрыш за одну ставку",
  ProvablyFairSubTitle:
    "В этой игре используется технология Provably Fair для определения результата. Этот инструмент позволяет изменить ваш сид и проверить честность игры.",
  ProvablyFairMaximumBet: "Максимальная ставка:",
  ProvablyFairMaxWinFor1Bet: "Максимальный выигрыш за одну ставку",
  promotionsTitle: "Акции",
  promotionsNoLosingData: "Извините, нет доступных бонусов на проигрыш для ",
  promotionsNoDepositData: "Извините, нет доступных депозитных бонусов для ",
  promotionsCurrency: " валюты.",
  promotionsViewBtn: "Просмотр",
  promotionsClaimSuccess: "Вы успешно получили",
  promotionsAvailability: "Доступность: ",
  promotionsAvailabilityTabLosing: "Бонус за проигрыш",
  promotionsAvailabilityTabDeposit: "Депозитный бонус",
  promotionsDepositBonusTableCode: "Код",
  promotionsDepositBonusTableMinDeposit: "Мин. депозит",
  promotionsDepositBonusTablePercentage: "Процент",
  promotionsDepositBonusTableMaxBonus: "Макс. бонус",
  promotionsDepositBonusTableRolloverMultipler: "Множитель отыгрыша",
  promotionsDepositBonusTableMaxRolloverPerBet: "Макс. отыгрыш за ставку",
  promotionsDepositBonusTableTimeToAchieveRolloverTarget:
    "Время для достижения цели по отыгрышу",
  promotionsBonusCode: "БОНУС-КОД: ",
  promotionsLossesClaim:
    "Проигрыши можно получить (в течение периода кампании): ",
  promotionsLossesClaimLosingBonusTablePercentage: "Процент",
  promotionsLossesClaimLosingBonusTableMinLosingAmount: "Мин. проигрыш",
  promotionsBonusStatus: "Статус бонуса: ",
  promotionsBonusAmount: "Сумма бонуса: ",
  promotionsRolloverTarget: "Цель по отыгрышу: ",
  promotionsRolloverAchieved: "Отыгрыш достигнут: ",
  promotionsActivatebtn: "АКТИВИРОВАТЬ",
  promotionsClaimBtn: "ПОЛУЧИТЬ",
  promotionsCancelBtn: "ОТМЕНИТЬ",
  promotionsBackBtn: "НАЗАД",
  promotionsBonus: "Бонус",
  promotionsTermAndConditions: " Условия и положения",
  promotionsClaimDepositBonusTitle: "Шаги для получения депозитного бонуса",
  promotionsClaimDepositBonusFirst: "Активируйте бонус-код",
  promotionsClaimDepositBonusSecond: "Внесите депозит на кошелёк",
  promotionsClaimDepositBonusThird:
    "Достигните цели по отыгрышу для получения бонуса",
  promotionsClaimLosingBonusTitle: "Шаги для получения бонуса за проигрыш",
  promotionsClaimLosingBonusFirst: "Активируйте бонус-код",
  promotionsClaimLosingBonusSecond: "Играйте в любимые игры",
  promotionsClaimLosingBonusThird:
    "Нажмите 'Получить проигрыши', чтобы получить компенсацию",
  promotionsWentWrong: "Что-то пошло не так!",
  transactionTitle: "Транзакции",
  transactionBetId: "ID ставки",
  transactionUser: "Пользователь",
  transactionPayout: "Выплата",
  transactionAmount: "Сумма",
  transactionTime: "Дата",
  transactionProfit: "Профит",
  transactionCashout: "Кэшаут",
  transactionBet: "Ставка",
  transactionMultix: "Множитель x",
  transactionWin: "Выигрыш",
  transactionFairness: "Честность",
  transactionReferFriend: "Пригласить друга",
  transactionTotal: "Всего ставок",
  transactionWins: "Выигрыши",
  transactionRefresh: "Обновить",
  transactionFilterTopMultipliers: "Топ множителей",
  transactionFilterHugeWins: "Огромные выигрыши",
  transactionFilterBiggestWins: "Самые большие выигрыши",
  transactionFilterMultipliers: "Множители",
  transactionRealBalance: "Реальный баланс",
  depositWithdrawTXDate: "Дата",
  depositWithdrawTXAmount: "Сумма",
  depositWithdrawTXTxId: "TxID",
  depositWithdrawTXTxType: "Тип транзакции",
  depositWithdrawTXStatus: "Статус",
  depositWithdrawTXNoData: "Нет данных.",
  depositTitle: "Депозит",
  depositHistory: "История",
  depositSubTitle:
    "Пользователь не может вносить или выводить фиатную валюту. Пожалуйста, свяжитесь с Администратором для операций с фиатом.",
  depositCopyNotSupported:
    "Ваш браузер не поддерживает копирование в буфер.\nПожалуйста, скопируйте код вручную.",
  depositCopied: "Адрес скопирован.",
  withdrawNoBalance: "Недостаточно средств.",
  withdrawMinAmount: "Введите сумму больше или равную {{min}}.",
  paginationNextBtn: "Далее",
  paginationPrevBtn: "Назад",
  LoginRequired: "Требуется вход!",
  betPlacedSuccessfully: "Ставка сделана",
  betCancelledSuccessfully: "Ставка отменена",
  PlayerEscapedSuccessfully: "Игрок вышел",
  CopiedSuccessfull: "Скопировано",
  usersConsent:
    "Получая доступ к сайту, я подтверждаю, что мне 18 лет и я ознакомился,\n понимаю и соглашаюсь с",
  termsOfService: "Условиями обслуживания",
  email: "Email",
  playNow: "Играть",
  orContinueWith: "Или продолжить с",
  metamaskExtensionNotAvailable:
    "Пожалуйста, установите расширение MetaMask и обновите страницу.",
  cashier: "ДЕПОЗИТ",
  account: "АККАУНТ",
  hello: "Привет",
  balance: "Баланс",
  referrals: "Рефералы",
  settings: "Настройки",
  withdrawals: "Выводы",
  demoWallet: "Демо-кошелёк",
  wallet: "Кошелёк",
  user: "Пользователь",
  amountIsRequired: "Сумма обязательна",
  minDepositAmount: "Сумма депозита должна быть больше {{min}}.",
  maxDepositAmount: "Сумма депозита должна быть меньше {{max}}.",
  minWithdrawAmount: "Должна быть больше {{min}}",
  withdrawMustLessThanWallet:
    "Сумма вывода должна быть меньше суммы в кошельке",
  accountTypeIsRequired: "Тип аккаунта обязателен.",
  mobileNumberLength: "Номер телефона должен быть {{length}} цифр",
  phoneIsRequired: "Телефон обязателен",
  cpfError: "CPF должен быть {{length}} символов",
  cpfRequiredError: "CPF обязателен",
  cnpjError: "CNPJ должен быть {{length}} символов",
  mainMenu: "ГЛАВНОЕ МЕНЮ",
  casino: "Казино",
  sports: "Спорт",
  crypto: "Крипто",
  NextGenXp: "NextGen XP",
  playEarn: "играй и зарабатывай",
  NFT: "NFT",
  poker: "Покер",
  earnRewards: "ПОЛУЧАЙ НАГРАДЫ",
  rankUp: "Повышай ранг",
  inviteFriends: "Пригласить друзей",
  affiliates: "Партнёры",
  sportsbook: "Спортивные ставки",
  menu: "Меню",
  allBets: "Все ставки",
  highRollers: "Крупные игроки",
  luckyBets: "Удачные ставки",
  trade: "Торговля",
  player: "ИГРОК",
  time: "ВРЕМЯ",
  wager: "СТАВКА",
  payoutText: "ВЫПЛАТА",
  bannerHeadOne: "Испытайте настоящие инновации с самой высокой",
  bannerHeadTwo: "программой вознаграждений в индустрии.",
  registerNow: "Зарегистрироваться",
  copy: "Копировать",
  liveWins: "ЖИВЫЕ ВЫИГРЫШИ",
  monthlyStatus: "М",
  weeklyStatus: "Н",
  dailyStatus: "Д",
  nextEcosystem: "экосистема nextgen",
  allGames: "Все игры",
  allSports: "Все виды спорта",
  cryptoFutures: "крипто-фьючерсы",
  tradeNow: "Торговать",
  allTables: "Все столы",
  nft: "NFT",
  viewAll: "Смотреть все",
  rewards: "Награды",
  profile: "Профиль",
  nextgenProfile: "NEXTGEN ПРОФИЛЬ",
  totalBets: "Всего ставок",
  totalWagered: "Всего поставлено",
  joinDate: "Дата регистрации",
  displaySocialLinks: "Показать привязанные социальные сети",
  privateProfile: "Приватный профиль",
  rank: "Ранг",
  nextRank: "Следующий ранг",
  changeUsername: "Изменить имя пользователя",
  newPassword: "Новый пароль",
  repeatNewPassword: "Повторите новый пароль",
  changeName: "Изменить имя",
  linkSocialAccount: "Привязать соц. аккаунт",
  privateProfileTooltip:
    "Если профиль скрыт, другие пользователи не смогут видеть вашу активность, награды или соц. ссылки.",
  socialLinksTooltip:
    "Привяжите социальные сети, чтобы другие пользователи могли подписаться на вас.",
  balances: "Баланс",
  createReferralBalance: "Создать реферальный баланс",
  total: "Итого",
  tips: "Чаевые",
  receivedAmount: "Полученная сумма",
  dateOrTime: "Дата/Время",
  view: "Просмотр",
  allChains: "Все сети",
  creditAmount: "Сумма кредита",
  setCustomReferralLink: "Установить пользовательскую реферальную ссылку",
  changeEmail: "Изменить email",
  newEmail: "Новый email",
  newUsername: "Новое имя пользователя",
  username: "Имя пользователя",
  changePassword: "Изменить пароль",
  twoFactorAuthentication: "двухфакторная аутентификация",
  twoFactorAuthenticationTitle:
    "Двухфакторная аутентификация настоятельно рекомендуется, так как защищает ваш аккаунт паролем и телефоном. Для активации 2FA должны быть установлены email и пароль. Пока 2FA включена, вход через Steam будет недоступен.",
  enable2fa: "Включить 2FA",
  verifyIdentityByKyc: "Подтвердить личность (KYC)",
  oldPassword: "Старый пароль",
  live: "Live",
  soccer: "Футбол",
  tennis: "Теннис",
  fifa: "Fifa",
  basketball: "Баскетбол",
  iceHockey: "Хоккей",
  volleyball: "Волейбол",
  tableTennis: "Настольный теннис",
  baseball: "Бейсбол",
  golf: "Гольф",
  boxing: "Бокс",
  myBets: "Мои ставки",
  favourites: "Избранное",
  americanFootball: "Американский футбол",
  buyCrypto: "Купить крипто",
  oldEmail: "Старый email",
  loggedInSuccess: "Вход выполнен",
  loggedOutSuccess: "Выход выполнен",
  signup: "Регистрация завершена",
  tokenVerify:
    "Токен подтверждения отправлен на ваш email. Пожалуйста, подтвердите",
  emailVerify: "Email подтверждён",
  emailChangedSuccess: "Email обновлён",
  emailUpdateOtp: "OTP отправлен на новый email",
  profileUpdatedSuccess: "Профиль обновлён",
  otpVerified: "Одноразовый пароль (OTP) подтверждён",
  twoFADeactivated: "Двухфакторная аутентификация отключена",
  internalServerError: "Внутренняя ошибка сервера",
  unAuthorized: "Неавторизовано",
  dataNotFound: "Данные не найдены",
  setReferralLink: "Установить реферальную ссылку...",
  notFound: "Не найдено",
  nextgenOriginals: "Лучшие игры",
  status: "Статус",
  success: "Успешно",
  failed: "Не удалось",
  pending: "В ожидании",
  date: "Дата",
  to: "Кому",
  roundId: "ID раунда",
  bet: "Ставка",
  win: "Выигрыш",
  at: "в",
  downloadAll: "Скачать всё",
  gameText: "Игра",
  searchGames: "Поиск игр",
  provider: "Провайдер",
  search: "Поиск",
  all: "Все",
  sortBy: "Сортировать по",
  popular: "Популярное",
  loadMore: "Загрузить ещё",
  bitcoin: "Биткоин",
  btc: "BTC",
  chat: "Чат",
  loginToChat: "Войдите, чтобы писать в чат",
  send: "Отправить",
  expand: "Развернуть",
  collapse: "Свернуть",
  emailPlaceholder: "youremail@domain.com",
  removeFromFavourite: "Удалить из избранного",
  addToFavourite: "Добавить в избранное",
  verify: "Подтвердить",
  accountVerification: "Верификация аккаунта",
  recentlyPlayed: "Недавно играли",
  moreFrom: "Больше от",
  demoMode: "Демо-режим",
  providersList: "Список провайдеров",
  games: "Игры",
  providers: "Провайдеры",
  close: "Закрыть",
  joinedOn: "Присоединился",
  rewarded: "Награжден",
  saySomething: "Написать сообщение",
  addressIsRequired: "Требуется адрес",
  withdrawRequestSent: "Запрос на вывод отправлен. Ожидает подтверждения.",
  noMatchesFound: "Совпадений не найдено",
  tip: "Чаевые",
  sendTip: "Отправить чаевые",
  minAmount: "Сумма должна быть больше {{min}}",
  maxAmount: "Сумма должна быть меньше {{max}}",
  doNotShowTip: "Не показывать чаевые в чате",
  demoAvailable: "Демо доступно",
  denoNotAvailable: "Демо недоступно",
  goFullscreen: "На весь экран",
  endsAt: "Заканчивается через",
  inProgress: "В процессе",
  eventEnd: "Событие завершено",
  latestPromotions: "Последние акции",
  archived: "Архив",
  noPromotionsFound: "Акций не найдено",
  claim: "Забрать",
  add: "Добавить",
  viewDashboard: "Перейти в панель",
  prize: "Приз",
  timeLeft: "Оставшееся время",
  viewTransactions: "Посмотреть транзакции",
  sendAmountInCashier:
    "Отправьте сумму {{- currency}} по указанному адресу, чтобы получить эквивалент в Coins.",
  yourPersonalDepositAddress:
    "Ваш персональный адрес для депозита {{- currency}}",
  copyAddress: "Копировать адрес",
  theValueOfCurrencyMayChange:
    "Стоимость {{- currency}} может измениться до момента получения вашего платежа",
  doNotHaveAnyCurrency: "Нет {{- currency}}?",
  depositOptions: "Способы депозита",
  withdrawalOptions: "Способы вывода",
  withdrawCurrency: "Вывод {{- currency}}",
  enterAddressToReceiveFunds:
    "Введите адрес кошелька {{- currency}}, на который хотите получить средства. После подтверждения вывод обычно обрабатывается в течение нескольких минут.",
  receivingCurrencyAddress: "Адрес получения {{- currency}}",
  withdrawalAmount: "Сумма вывода",
  pasteYourCurrencyAddressHere:
    "Вставьте здесь адрес вашего {{- currency}} кошелька...",
  request: "Запросить",
  receiveTheSpecifiedAmount:
    "*Вы получите указанное количество {{- currency}} на адрес вывода",
  valueMayVary:
    "*Сумма, списанная с вашего баланса, может измениться до момента обработки транзакции",
  coupons: "Купоны",
  updateEmail: "Обновить email",
  update: "Обновить",
  loginHistory: "История входов",
  showLoginHistory: "Показать историю входов",
  wagerErr: "Требуется указать сумму ставки",
  minWagerErr: "Минимальная сумма ставки — 1",
  mulValErr: "Значение множителя должно быть между 1 и 1000",
  closeBetErr: "Введите корректную сумму закрытия ставки",
  profitErr: "Введите корректную сумму прибыли",
  multiplierErr: "Требуется указать множитель",
  manual: "Ручной",
  auto: "Авто",
  pnLFee: "Комиссия PnL",
  flatFee: "Фиксированная комиссия",
  takeProfitLabel: "ЗАКРЫТЬ СТАКУ ПО ЦЕНЕ",
  closeBetLabel: "ЗАКРЫТЬ СТАВКУ ПО ЦЕНЕ",
  priceUpLabel: "ЦЕНА ВЫРАСТЕТ ИЛИ УПАДЁТ?",
  up: "Вверх",
  down: "Вниз",
  payoutMul: "МНОЖИТЕЛЬ ВЫПЛАТ",
  safe: "Безопасно",
  wild: "Рискованно",
  placeBet: "Сделать ставку",
  roundEnd: "РАУНД ЗАКОНЧИТСЯ ЧЕРЕЗ",
  timerInfo:
    "Все ставки в Rollercoaster будут закрыты, и цена сбросится до $1,000 ежедневно в 00:00 UTC",
  month: "месяц",
  PNL: "П/У",
  ROI: "ROI",
  roi: "roi",
  funding: "Фандинг/ч",
  exitPriceLabel: "Цена выхода",
  cashedOut: "Выведено",
  open: "Открыто",
  chartPreferences: "Настройки графика",
  yAxis: "Настройки оси Y",
  additionalFeatures: "Дополнительные функции",
  themes: "Темы",
  locale: "Язык интерфейса",
  changeTimezone: "Сменить часовой пояс",
  changeLanguage: "Сменить язык",
  tooltip: "Подсказка",
  field: "Поле",
  value: "Значение",
  dateTime: "Дата/Время",
  winningAmount: "Сумма выигрыша",
  activeBets: "Активные ставки",
  closedBets: "Закрытые ставки",
  publicBets: "Публичные ставки",
  leaderboard: "Таблица лидеров",
  howToPlay: "Как играть",
  rOICalculator: "Калькулятор ROI",
  allInstruments: "Все инструменты",
  week: "Неделя",
  monthLabel: "Месяц",
  day: "День",
  betLabel: "СТАВКА",
  entryPrice: "ЦЕНА ВХОДА",
  bustPriceLabel: "Цена ликвидации",
  multiplierLabel: "МУЛЬТИПЛИКАТОР",
  exitPrice: "ЦЕНА ВЫХОДА",
  pnl: "П&У",
  details: "Подробнее",
  profitLoss: "Прибыль и убыток",
  noBalance: "Недостаточно средств.",
  maxBetAmount: "Максимальная сумма ставки",
  limit: "лимит превышен.",
  minBetAmount: "Минимальная сумма ставки",
  rollsLimitMsg: "Количество бросков должно быть ≤ 100.",
  mines: "Мины",
  loginFailed: "Не удалось войти",
  noEntries: "Нет записей",
  descriptionIsRequired: "Описание обязательно",
  description: "Описание",
  report: "Пожаловаться",
  userReportedSuccessfully: "Пользователь успешно отмечен",
  tipSendSuccessfully: "Чаевые отправлены",
  walletSettings: "Настройки кошелька",
  hideZero: "Скрыть нулевые балансы",
  hideZeroInfo: "Ваши нулевые балансы не будут отображаться",
  displayFiat: "Показывать крипто в фиате",
  displayFiatInfo:
    "Все ставки и транзакции будут рассчитаны в эквиваленте криптовалюты",
  noteForApprox:
    "Пожалуйста, обратите внимание, что это приблизительные значения валют.",
  save: "Сохранить",
  limits: "Лимиты",
  wagerLimit: "Лимит ставок",
  lossLimit: "Лимит потерь",
  depositLimit: "Лимит депозита",
  takeABreak: "Сделать перерыв",
  customTimePeriod: "Пользовательский период",
  timePeriod: "Период",
  selfExclusion: "Самоисключение",
  confirm: "Подтвердить",
  setLimit: "Установить лимит",
  removeLimit: "Удалить лимит",
  enterAmount: "Введите сумму",
  hours: "Часы",
  daily: "Ежедневно",
  weekly: "Еженедельно",
  monthly: "Ежемесячно",
  cancel: "Отменить",
  usedLimit: "Использованный лимит",
  type: "Тип",
  updatedAt: "Обновлено",
  editLimit: "Редактировать лимит",
  limitRemovedMessage: "Следующий лимит будет удалён.",
  setLimitMessage:
    "Вы собираетесь установить следующий лимит для вашего аккаунта. Пожалуйста, обратите внимание: изменить лимит вы сможете через 24 часа.",
  setBreakMessage:
    "Вы собираетесь заблокировать доступ к своему аккаунту на определённый период. После активации вы не сможете войти в аккаунт для изменения периода. Для изменений обращайтесь в поддержку.",
  setSessionLimitMessage:
    "Вы устанавливаете лимит на сессию. Если вы захотите его изменить, новые ограничения вступят в силу через 24 часа.",
  removeSessionLimitMessage: "Лимит сессии будет удалён",
  notAchieved: "не достигнуто",
  flexibleRegistration: "Гибкая регистрация!",
  mostPlayed: "Самые популярные",
  badge: "Значки",
  allBadges: "Все значки",
  socialMedia: "Социальные сети",
  allLinks: "Все ссылки",
  statistics: "Статистика",
  newMessage: "Новое сообщение",
  tipFor: "чаевые для",
  play: "Играть",
  betOn: "Ставить на",
  liveCasino: "Живое казино",
  ecosystemUnbeatableOdds:
    "Ставьте лучше — получайте лучшие коэффициенты на захватывающие события!",
  startBetting: "Начать ставить",
  ecosystemJoinTheFun:
    "Присоединяйтесь — исследуйте эксклюзивные игры NextGen и более 9 000 казино-игр!",
  futures: "Фьючерсы",
  ecosystemTrade:
    "NGB — ваш надёжный портал в будущее игровой индустрии и ставок!",
  ecosystemCasino24x7:
    "Почувствуйте азарт реального казино с профессиональными дилерами 24/7!",
  joinNow: "Присоединиться",
  noNotificationsFound: "Нет уведомлений",
  notifications: "Уведомления",
  lobby: "Лобби",
  rollercoaster: "NextGen Coaster",
  applyReferralCode: "Применить реферальный код",
  referralCode: "Реферальный код",
  referralLink: "Реферальная ссылка",
  copyLink: "Скопировать ссылку",
  referralLinkCopied: "Ссылка скопирована",
  withdrawAddressCannotBeSame:
    "Адрес вывода не может совпадать с вашим собственным адресом",
  userId: "ID пользователя",
  active: "Активен",
  inactive: "Неактивен",
  currency: "Валюта",
  hostGames: "Проводите игры,",
  earnCrypto: "Зарабатывайте криптовалюту",
  inviteHostAndEarn:
    "Приглашайте, проводите и зарабатывайте — создавайте свои события NextGen",
  startEarning: "Начать зарабатывать",
  nextGen: "NextGen",
  whitePaper: "Whitepaper",
  deepDiveInto: "Глубокое погружение в экономику монеты NextGen",
  learnMore: "Узнать больше",
  sport: "спорт",
  vipRanked: "VIP ранг",
  betMoreEarnMore: "Ставьте больше — зарабатывайте больше",
  expiresAt: "Истекает",
};
